module.exports = __webpack_public_path__ + "assets/logo-medistream.6f96649c.svg";